import api from '@/services/api'

export interface FAQ {
  id: string
  tenantId: string
  question: string
  answer: string
  keywords: string // Comma-separated string
  active: boolean
  createdAt: string
  updatedAt: string
}

export interface FAQCreateInput {
  question: string
  answer: string
  keywords: string[]
  active?: boolean
}

export interface FAQUpdateInput {
  question?: string
  answer?: string
  keywords?: string[]
  active?: boolean
}

export async function getFAQs(keyword?: string) {
  const params = keyword ? { keyword } : {}
  const { data } = await api.get<FAQ[]>('/bot/faqs', { params })
  return data
}

export async function createFAQ(faq: FAQCreateInput) {
  const { data } = await api.post<FAQ>('/bot/faqs', faq)
  return data
}

export async function updateFAQ(id: string, faq: FAQUpdateInput) {
  const { data } = await api.put<FAQ>(`/bot/faqs/${id}`, faq)
  return data
}

export async function deleteFAQ(id: string) {
  await api.delete(`/bot/faqs/${id}`)
}

// Helper para convertir keywords string a array
export function parseKeywords(keywords: string): string[] {
  if (!keywords) return []
  return keywords.split(',').map(k => k.trim()).filter(k => k.length > 0)
}

// Helper para convertir keywords array a string
export function stringifyKeywords(keywords: string[]): string {
  return keywords.join(',')
}

